import { camelizeKeys } from "humps";
import { cmsClient } from "src/services/cmsClient";
import { ObservationCategoryOutputSchema as Schema } from "src/features/Admin/Observations/models";
import { useQuery } from "@tanstack/react-query";

const fetchObservationCategory = async (categoryId?: number) => {
	const url = `/observations/admin/forms/categories/${categoryId}/`;

	const response = await cmsClient.get(url);
	const camelizedData = camelizeKeys(response.data);

	return Schema.parse(camelizedData);
};

type UseObservationCategoryOptions = {
	enabled?: boolean;
};

const useObservationCategory = (
	id?: number,
	options: UseObservationCategoryOptions = { enabled: true }
) => {
	const { enabled } = options;

	const queryKey = ["observation-category", id];
	const queryFn = () => fetchObservationCategory(id);

	const query = useQuery({
		queryKey,
		queryFn,
		enabled
	});

	return query;
};

export default useObservationCategory;
